export enum AudioVideoView {
    Dialog = 'dialog',
    Conference = 'conference',
}
